/**
 * Created by emilgrabowiec on 21.04.2016.
 */
$(() => {
  $('.select-month').select2({
    placeholder: __('Select Month'),
    minimumResultsForSearch: Infinity
  });

  $('.select-year').select2({
    placeholder: __('Select Year'),
    minimumResultsForSearch: Infinity
  });

  $('.select-bank-account').select2({
    placeholder: __('Select Type'),
    minimumResultsForSearch: Infinity
  });

  $('#payVisa').on('click', () => {
    $('.form-pay').addClass('visible');
    $('.form-pay-ach').removeClass('visible');
    $('.form-pay').css('display', 'block');
    $('.form-pay-ach').css('display', 'none');
  });

  $('#payACH').on('click', () => {
    $('.form-pay').removeClass('visible');
    $('.form-pay-ach').addClass('visible');
    $('.form-pay').css('display', 'none');
    $('.form-pay-ach').css('display', 'block');
  });

  $('#payCheck').on('click', () => {
    $('.form-pay').removeClass('visible');
    $('.form-pay-ach').removeClass('visible');
    $('.form-pay').css('display', 'none');
    $('.form-pay-ach').css('display', 'none');
  });
});
